import type { ReactNode } from 'react';

import { generatePath, Navigate } from 'react-router';

import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { resolveAutomationHubPath } from '~/routing/automationHubPaths';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

interface Props {
  legacyPath: RoutePathType;
  children: ReactNode;
}

export function AutomationHubLegacyRoute({ legacyPath, children }: Props) {
  const hasStdAiUrlMigration = useFlag(FlagType.StdAiUrlMigration);
  const { params, location } = useRouting();

  if (!hasStdAiUrlMigration) {
    return <>{children}</>;
  }

  const customAiPath = resolveAutomationHubPath(legacyPath, true);
  const to = `${generatePath(customAiPath, params)}${location.search}`;
  return <Navigate replace to={to} />;
}
